import Landing from "./Landing.svelte";
import NotFound from "./NotFound.svelte";
import Dashboard from "./Dashboard.svelte";
import Policy from "./Policy.svelte";
import Pricing from "./Pricing.svelte";
export const routes = {
    // Exact path
    "/": Landing,
    // Using named parameters, with last being optional
    "/policy/:type": Policy,
    "/pricing": Pricing,
    "/app": Dashboard,
    "*": NotFound,
};
